<template>
  <div class="main-box">
    <ball></ball>
    <van-nav-bar
      title="排队叫号"
      left-arrow
      left-text="返回"
      @click-left="onClickLeft"
    />
    <van-popup
      v-model="show"
      closeable
      position="bottom"
      :style="{ height: '40%' }"
    >
      <div class="pop_body">
        <div class="pop_title">科室列表</div>
        <div class="pop_radio">
          <van-radio-group v-model="radio">
            <van-cell-group>
              <van-cell
                clickable
                v-for="(item, index) in dypeList"
                :key="index"
                @click="getdept(item)"
                :title="item.deptName"
              >
                <template #right-icon>
                  <van-radio :name="item.deptId" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </div>
        <div class="pop_btn"></div>
      </div>
    </van-popup>
    <div class="Queuing_body">
      <div class="body_title">{{ deptName }}</div>
      <div class="body_number">
        <div class="body_number_title">当前号数:</div>
        <div class="body_number_a"></div>
        <div class="body_number_b">{{ num }}</div>
      </div>
      <div class="body_name">{{name}}</div>
      <div class="body_foot">
        <!-- 等候人数:<span style="color: #5b8df6;fontSize:18px"> &nbsp12 &nbsp</span>人 -->
      </div>
    </div>
  </div>
</template>

<script>
import setOptions from "@/mixins/setOption";
import Nav from "@/components/nav.vue";
import { Dialog } from "vant";
import backindex from "@/mixins/backindex";
export default {
  mixins: [setOptions, backindex],
  data() {
    return {
      medCardNo: "",
      dypeList: null,
      cardList: null,
      show: false,
      radio: "",
      deptName: "",
      num: "",
      name:""
    };
  },
  components: {
    Nav,
  },
  created() {
    if (this.$route.query) {
      this.medCardNo = this.$route.query.clientId;
      // console.log(this.medCardNo)
    }
    if (!this.medCardNo || this.medCardNo == "") {
      // console.log(this.medCardNo);
      this.goconfUser();
      // this.Dialog();
    }
    this.getDeptList();
    this.getregList();
  },
  methods: {
    async getdept(item) {
      this.radio = item.deptId;
      this.deptName = item.deptName;
      this.show = false;
      let clinicId = null;
      clinicId = this.cardList.find(
        element =>
          element.deptId == this.radio &&
          !element.seeFlag &&
          new Date(element.regDate.substr(0, 10)) <= new Date()
      );

      if (!clinicId) {
        this.$toast.fail("暂时没有可用挂号");
        return;
      } else {
        try {
          this.$showLoad();
          let url = "/register/registerline";
          let medCardNo = {
            clinicId: clinicId.clinicId,
          };
          await this.$axios_request.axios_request_body(
            "nodeserver",
            url,
            "POST",
            medCardNo,
            (data) => {
              this.$hideLoad();
              if (data.data.length != 0 && data.data.data.data[0].seeNo) {
                this.num = data.data.data.data[0].seeNo;
                this.name=data.data.data.data[0].clientName
              } else {
                this.$toast.fail("网络失败，稍后重试");
              }
            }
          );
        } catch (error) {}
      }
    },
    goconfUser() {
      this.$router.push("/patient_card_confUser_C");
    },
    //
    onClickLeft() {
      this.$router.push("/index");
    },
    getyDay(date) {
      date.setTime(date.getTime());
      date =
        date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
      return date;
    },
    async getregList() {
      // console.log(this.medCardNo)
      try {
        this.$showLoad();
        let url = "/register/registerRecord";
        let medCardNo = {
          medCardNo: this.medCardNo,
          start_date: this.getyDay(new Date()) + " 00:00:00",
          end_date: this.getyDay(new Date()) + " 23:59:59",
        };
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          medCardNo,
          (data) => {
            this.$hideLoad();
            if (data.data.length != 0) {
              this.cardList = data.data;
            } else {
              this.cardList = [];
            }
          }
        );
      } catch (error) {}
    },
    async getDeptList() {
      //获取科室列表
      try {
        this.$showLoad();
        let url = "/register/querydept";
        this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          null,
          async (data) => {
            this.dypeList = data.data.data;
            this.$hideLoad();
          if(this.medCardNo){
              this.$toast.success("请选择挂号科室");
          }
            this.show = true;
          }
        );
      } catch (error) {
        // console.log(error);
        this.$hideLoad();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main-box {
  width: 100vw;
  max-height: 100vh;
  background: white;
  .pop_body {
    display: flex;
    flex-direction: column;
    width: 100vw;
    height: 40vh;
    .pop_title {
      width: 90vw;
      font-size: 16px;
      margin: 0px auto;
      text-align: center;
      margin-top: 2vh;
    }
    .pop_radio {
      margin-top: 2vh;
      max-height: 30vh;
    }
    .pop_btn {
    }
  }
  .Queuing_body {
    display: flex;
    flex-direction: column;
    width: 100vw;
    max-height: 100vh;
    .body_title {
      width: 45vw;
      margin: 0 auto;
      text-align: center;
      margin-top: 5vh;
      margin-bottom: 1vh;
      background-color: #f2f2f2;
      height: 6vh;
      line-height: 6vh;
      font-size: 16px;
      border: 2px solid #f2f2f2;
      border-radius: 25px;
    }
    .body_number_title{
      margin-bottom: 2vh;
    }
    .body_number {
      width: 90vw;
      margin: 0 auto;
      text-align: center;
      margin-top: 5vh;

      .body_number_a {
        background-color: #5b8df6;
        opacity: 10%;
        width: 31vh;
        height: 31vh;
        margin: 0px auto;
        border-radius: 50%;
        z-index: 0;
      }
      .body_number_b {
        background-color: #5b8df6;
        width: 26vh;
        height: 25vh;
        margin: -28vh auto;
        border-radius: 50%;
        line-height: 25vh;
        font-size: 15vh;
        color: white;
      }
      margin-bottom: 10vh;
    }
    .body_name {
      width: 90vw;
      margin: 0 auto;
      text-align: center;
      margin-top: 30vh;
      margin-bottom: 2vh;
    }
    .body_foot {
      width: 90vw;
      margin: 0 auto;
      text-align: center;
      margin-top: 1vh;
      font-size: 16px;
    }
  }
}
</style>